/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  PresenterError,
  PresenterOneRoleResponse,
  PresenterResponse,
  PresenterSaveRoleRequest,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Roles<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * @description List roles
   *
   * @tags roles
   * @name GetRoles
   * @summary List the roles
   * @request GET:/roles
   */
  getRoles = (
    query?: {
      "filter[name]"?: string;
      sort?: string[];
      "page[number]"?: number;
      "page[size]"?: number;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterOneRoleResponse[];
      },
      PresenterError
    >({
      path: `/roles`,
      method: "GET",
      query: query,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Create role
   *
   * @tags roles
   * @name PostRoles
   * @summary Create the role
   * @request POST:/roles
   */
  postRoles = (body: PresenterSaveRoleRequest, params: RequestParams = {}) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterOneRoleResponse;
      },
      PresenterError
    >({
      path: `/roles`,
      method: "POST",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description GetDefault role
   *
   * @tags roles
   * @name GetRolesDefault
   * @summary GetDefault the role
   * @request GET:/roles/default
   */
  getRolesDefault = (params: RequestParams = {}) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterOneRoleResponse;
      },
      PresenterError
    >({
      path: `/roles/default`,
      method: "GET",
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description GetByBIID role
   *
   * @tags roles
   * @name GetRolesByBiid
   * @summary GetByBIID the role
   * @request GET:/roles/{biid}
   */
  getRolesByBiid = (biid: string, params: RequestParams = {}) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterOneRoleResponse;
      },
      PresenterError
    >({
      path: `/roles/${biid}`,
      method: "GET",
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Update role
   *
   * @tags roles
   * @name PutRolesByBiid
   * @summary Update the role
   * @request PUT:/roles/{biid}
   */
  putRolesByBiid = (
    biid: string,
    body: PresenterSaveRoleRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterOneRoleResponse;
      },
      PresenterError
    >({
      path: `/roles/${biid}`,
      method: "PUT",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete role
   *
   * @tags roles
   * @name DeleteRolesByBiid
   * @summary Delete the role
   * @request DELETE:/roles/{biid}
   */
  deleteRolesByBiid = (biid: string, params: RequestParams = {}) =>
    this.http.request<PresenterResponse, PresenterError>({
      path: `/roles/${biid}`,
      method: "DELETE",
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
